import { render, staticRenderFns } from "./OtpHistoryDialog.vue?vue&type=template&id=3b6fd9e3&scoped=true&"
import script from "./OtpHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./OtpHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./OtpHistoryDialog.vue?vue&type=style&index=0&id=3b6fd9e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fd9e3",
  null
  
)

export default component.exports